window.addEventListener('scroll', () => {
    document.getElementById('btn-open-form')?.classList.toggle('visible', window.scrollY >= 200);
});
